import React from 'react';
import Header from './Header';
import ChoiceArea from './ChoiceArea';



const App = () => {
  return (
    <div className="app">
      <Header />
      <ChoiceArea />

    </div>
  )
}


export default App;